export enum PlayerAgentLoaders {
    isShowUsersLoading,
    isCreateUserLoading,
    isDepositSending,
    isWithdrawLoading
}